import { createApiRequest } from "../common";
import { UpdateOrgRequestContent, UpdateOrgResponseContent } from '@equaliq/api-model';

export const updateOrgApi = async (request: UpdateOrgRequestContent): Promise<UpdateOrgResponseContent> => {
  const apiRequest = createApiRequest<UpdateOrgResponseContent>('post', '/orgs/update');
  return apiRequest(request);
};
